export enum Purpose {
  RefinancingLoan = 'Refinancing loan',
  Renovation = 'Renovation',
  Vehicle = 'Vehicle',
  Other = 'Other',
  Holiday = 'Holiday',
  UnexpectedExpenses = 'Unexpected expenses',
  RealEstate = 'Real estate',
  Medical = 'Medical',
  SpecialOccasion = 'Special occasion',
  Investment = 'Investment',
  GreenEnergy = 'Green energy',
  PropertyDivision = 'Property division',
  HomeInteriorDesign = 'Home interior design',
  EstateInventory = 'Estate inventory',
  Wedding = 'Wedding',
  DebtCollection = 'Debt collection',
  InvestmentOwnCompany = 'Investment own company',
  Consumption = 'Consumption',
  DrivingLicense = 'Driving license',
  Studies = 'Studies',
  Dentist = 'Dentist',
  Housing = 'Housing',
}
